<template>
    <div>
        <b-modal :id="String(data.id + 'account_statement')" size="xl" @shown="modalShown">
            <template #modal-title>
                <div class="d-flex">
                    <h6 class="m-0 fw-bold text-green">Product Statement</h6>
                    <div class="akkurate-small me-4">
                        <span v-if="rewrtieLoading">
                            <b-spinner small class="align-middle"></b-spinner>
                        </span>
                        <b-link v-else class="fw-semibold ms-2 akkurate-green">
                            <font-awesome-icon :icon="['fas', 'arrow-rotate-left']" @click="refreshLoanTransactions(data.customer_id)" /></b-link>

                    </div>
                </div>


            </template>
            <div class="container mb-1">
                <div class="row">
                    <form @submit.prevent="filterAccountStatement">
                        <statement-filter :filter="filter" :is-searching="isSearching" :search="search"></statement-filter>
                    </form>
                </div>
            </div>


            <hr style="margin: 0.25rem;" />


            <div class="container text-start" ref="pdfContent">
                <div class="row">
                    <div class="col-md-4 col-4 d-flex align-items-center flex-column bd-highlight">
                        <img class="img-fluid img-visibility statement-logo" :src="require('@/assets/img/default_logo.png')">
                        <p class="mt-2 akkurate-green fw-bold mt-auto p-2 bd-highlight">STATEMENT OF ACCOUNT</p>
                    </div>
                    <div class="d-flex align-items-end flex-column bd-highlight col-md-8 col-8 text-end">
                        <p class="fw-bold text-uppercase mb-0">{{ institution?.name }}</p>
                        <p class="fw-bold">{{ institution?.motto }}</p>
                        <p class="mb-0 akkurate-small">{{ institution?.postal }}</p>
                        <p class="mb-0 akkurate-small">{{ institution?.telephone }}</p>
                        <p class="akkurate-small">{{ institution?.email }}</p>
                        <p class="fw-bold text-end mt-auto p-2 bd-highlight text-uppercase">{{ new
                            Intl.DateTimeFormat('en-GB', {
                                day: 'numeric', month: 'long', year: 'numeric'
                            }).format(Date.now()) }}</p>
                    </div>
                </div>
                <hr class="mt-0 akkurate-dark" />
                <div class="row">
                    <div class="col-md-5">
                        <h6 class="akkurate-dark report-l-text">PRODUCT DETAILS</h6>
                        <hr class="w-100 mt-0" />
                        <div class="row akkurate-small">
                            <div class="col-md-4 fw-bold akkurate-gray report-l-text">
                                Customer Name
                            </div>
                            <div class="col-md-8">
                                {{ getFullNameAndID }}
                            </div>
                            <div class="col-md-4 fw-bold akkurate-gray report-l-text">
                                Account Name
                            </div>
                            <div class="col-md-8">
                                {{ form.account_type?.name }}
                            </div>
                            <div class="col-md-4 fw-bold akkurate-gray report-l-text">
                                Account Number
                            </div>
                            <div class="col-md-8">
                                {{ form.account_number }}
                            </div>
                            <div class="col-md-4 fw-bold akkurate-gray report-l-text">
                                Branch
                            </div>
                            <div class="col-md-8">
                                {{ form.branch?.name }}
                            </div>
                            <div class="col-md-4 fw-bold akkurate-gray report-l-text">
                                Currency
                            </div>
                            <div class="col-md-8 report-s-text">
                                {{ institution?.currency_code }}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3"></div>
                    <div class="col-md-4">
                        <h6 class="akkurate-dark report-l-text">PRODUCT SUMMARY</h6>
                        <hr class="w-100 mt-0" />
                        <div class="row akkurate-small">
                            <div class="col-md-5 fw-bold akkurate-gray report-l-text">
                                Opening Balance
                            </div>
                            <div class="col-md-7">
                                {{ displayNumber(form.opening_balance) }}
                            </div>
                            <div class="col-md-5 fw-bold akkurate-gray report-l-text">
                                Total Debit
                            </div>
                            <div class="col-md-7">
                                {{ displayNumber(form.total_debits) }}
                            </div>
                            <div class="col-md-5 fw-bold akkurate-gray report-l-text">
                                Total Credit
                            </div>
                            <div class="col-md-7">
                                {{ displayNumber(form.total_credits) }}
                            </div>
                            <hr class="w-100 mt-0 mb-2" />
                            <div class="col-md-5 fw-bold akkurate-gray akkurate-small report-l-text">
                                Closing Balance
                            </div>
                            <div class="col-md-7 fw-bold report-l-text akkurate-small">
                                {{ displayNumber(form.closing_balance) }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-md-6">
                        <h6 class="report-l-text">PRODUCT TRANSACTIONS</h6>
                    </div>
                    <div class="col-md-6 text-end">
                        <h6 class="report-l-text"><span class="fw-bold">From:</span> {{ filter.start_date }} <span class="fw-bold">To:</span> {{ filter.end_date }}</h6>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12 trans_details">
                        <b-table striped small :busy.sync="isBusy" :items="items" :fields="fields">
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>
                            <template #cell(reference)="data" class="text-nowrap text-center">
                                <p class="mb-0 text-nowrap">
                                    TRA{{ data.item.id }}</p>
                            </template>
                            <template #cell(trans_date)="data" class="text-nowrap text-center" style="width: 70px !important;">
                                <p class="mb-0 text-nowrap">
                                    {{ data.item?.trans_date }}</p>
                            </template>
                            <template #cell(debit)="data">
                                <p class="mb-0" v-if="data.item.transaction_type == 'Withdrawal' || data?.item?.transaction_type == 'Loan Repayment'">
                                    {{
                                        displayNumber(data.item.trans_amount) }}</p>
                            </template>
                            <template #cell(credit)="data">
                                <p class="mb-0" v-if="data.item.transaction_type == 'Deposit' || data?.item?.transaction_type == 'Loan Disbursed'">
                                    {{ displayNumber(data.item?.trans_amount)
                                    }}</p>
                            </template>
                            <template #cell(teller)="data">
                                <p class="mb-0">{{ data.item?.created_user?.first_name }} {{
                                    data.item?.created_user?.surname }}</p>
                            </template>
                            <template #cell(current_balance)="data">
                                <p class="mb-0">{{
                                    displayNumber(data.item?.current_balance) }}</p>
                            </template>
                            <template #cell(previous_balance)="data">
                                <p class="mb-0">{{
                                    displayNumber(data.item?.previous_balance) }}</p>
                            </template>
                            <template #cell(trans_status)="data">
                                <span class="badge " :class="data.item.trans_status == 'COMPLETED' ? 'bg-success' : (data.item.trans_status == 'REVERSED' ? 'bg-danger' : 'bg-warning')">{{
                                    data.item.trans_status }}</span>
                            </template>
                        </b-table>
                    </div>

                </div>
                <div class="col-md-12 text-center">
                    *********************************
                    END OF STATEMENT
                    *********************************
                </div>


            </div>
            <template #modal-footer>
                <div class="w-100">
                    <!-- begin loader -->
                    <!-- <beat-loader-component class="float-left" v-if="isLoading"
                        :isLoading="isLoading"></beat-loader-component> -->
                    <!-- end loader -->
                    <!-- Emulate built in modal footer ok and cancel button actions -->
                    <b-button @click="printPDF" type="button" class="akkurate-green-btn download-btn ms-2 float-right"><span class="small"><font-awesome-icon :icon="['fas', 'book']" />Print</span></b-button>
                    <b-button @click="downloadPDF" class="akkurate-green-btn download-btn float-right"><span class="small"><font-awesome-icon :icon="['fas', 'save']" /> Download</span></b-button>
                </div>
            </template>

        </b-modal>
    </div>
</template>
<script>
import ApiService from "@/core/services/api.service";
import StatementFilter from './form/StatementFilter.vue'
import html2pdf from "html2pdf.js";
import StatementInstitution from "@/views/main/components/institution/StatementInstitution.vue";
export default {

    props: ['data', 'institution', 'user'],
    components: {
        StatementFilter,
        StatementInstitution
    },
    data() {
        return {
            filter: {
                account_number: "",
                start_date: this.getOneMonthBeforeDate(),
                end_date: new Date().toISOString().substr(0, 10),
            },
            frontImgUrl: "",
            backImgUrl: "",
            imageLoaded: false,
            form: {
                customer: [],
                account_type: [],
                branch: [],
            },
            rewrtieLoading: false,
            total_credit: 0,
            total_debit: 0,
            fields: [
                { key: 'trans_date', label: 'Date' },
                { key: 'reference', label: 'Reference' },
                { key: 'transaction_mode', label: 'Mode' },
                { key: 'trans_status', label: 'Status' },
                // { key: 'code', label: 'Trans. ID' },
                { key: 'narration', label: 'Description' },
                { key: 'debit', label: 'Debit' },
                { key: 'credit', label: 'Credit' },
                { key: 'previous_balance', label: 'Prev.Balance' },
                { key: 'current_balance', label: 'Balance' },
                // { key: 'teller', label: 'Teller' },
            ],
            items: [],
            search: "Search",
            isSearching: false,
            isBusy: false,

        }
    },
    computed: {
        getFullNameAndID() {
            let first_name = this.form.customer.first_name != null ? this.form.customer.first_name : "";
            let middlename = this.form.customer.middlename != null ? this.form.customer.middlename : "";
            let last_name = this.form.customer.last_name != null ? this.form.customer.last_name : "";
            let code = this.form.customer.code != null ? this.form.customer.code : "";
            return first_name + ' ' + middlename + ' ' + last_name + ' - ' + code;

        }
    },
    methods: {
        async getAccountStatement() {
            this.isSearching = true;
            this.search = "Processing..."
            this.isBusy = true;
            console.log(this.filter.account_number)
            this.filter.account_number = this.filter.account_number ? this.filter.account_number : this.data.account_number;
            await ApiService.query(`/accounts/statement/${this.filter.account_number}`, {
                params: {
                    start_date: this.filter.start_date,
                    end_date: this.filter.end_date,
                }
            })
                .then((response) => {
                    this.isSearching = false;
                    this.search = "Search"
                    this.isBusy = false;
                    this.form = response.data.account;
                    this.items = response.data.account.transactions;
                    // this.handleImageLoad();
                }).catch((error) => {
                    this.isSearching = false;
                    this.search = "Search"
                    this.isBusy = false;
                });
        },
        handleImageLoad() {
            this.imageLoaded = true;
            this.frontImgUrl = this.details.account?.customer?.gh_card_front_path;
            this.backImgUrl = this.details.account?.customer?.gh_card_back_path;
        },
        downloadPDF() {

            // console.log(this.items)

            const content = this.$refs.pdfContent; // Reference to the HTML content you want to convert
            // console.log("here");
            const pdfOptions = {
                margin: [0.3, 0.1, 1.2, 0.1],
                filename: 'statement.pdf',
                image: { type: 'jpeg', quality: 1.0 },
                html2canvas: { scale: 4, useCORS: true, letterRendering: true},
                jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
                pagebreak: {
                    mode: ['css', 'legacy']
                }

            };
            html2pdf()
                .from(content)
                .set(pdfOptions)
                .toPdf()
                .get('pdf')
                .then((pdf) => {
                    var totalPages = pdf.internal.getNumberOfPages();
                    var insit_name = this.institution.name;
                    var insit_tele = this.institution.telephone;
                    var insit_email = this.institution.email;
                    var insit_motto = this.institution.motto;

                    for (var i = 1; i <= totalPages; i++) {
                        pdf.setPage(i);
                        pdf.setFontSize(8);
                        pdf.setTextColor(150);
                        pdf.text(["For Inquiries, Please Contact " + insit_name + ", Customer Service on " + insit_tele + "", "or email us on " + insit_email + " " + insit_motto + "", "Page " + i + " of " + totalPages], pdf.internal.pageSize.getWidth() / 2, pdf.internal.pageSize.getHeight() - 0.6, { align: "center" });
                    }
                }).save();

        },
        printPDF() {
            const content = this.$refs.pdfContent; // Reference to the HTML content you want to convert
            // console.log("here");
            const pdfOptions = {
                margin: [0.3, 0.1, 1.2, 0.1],
                filename: 'statement.pdf',
                image: { type: 'jpeg', quality: 1.0 },
                html2canvas: { scale: 4, useCORS: true, letterRendering: true },
                jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
                pagebreak: {
                    mode: ['css', 'legacy']
                }
            };
            html2pdf()
                .from(content)
                .set(pdfOptions)
                .toPdf()
                .get('pdf')
                .then((pdf) => {
                    var totalPages = pdf.internal.getNumberOfPages();
                    var insit_name = this.institution.name;
                    var insit_tele = this.institution.telephone;
                    var insit_email = this.institution.email;
                    var insit_motto = this.institution.motto;
                    for (var i = 1; i <= totalPages; i++) {
                        pdf.setPage(i);
                        pdf.setFontSize(8);
                        pdf.setTextColor(150);
                        pdf.text(["For Inquiries, Please Contact " + insit_name + ", Customer Service on " + insit_tele + "", "or email us on " + insit_email + " " + insit_motto + "", "Page " + i + " of " + totalPages], pdf.internal.pageSize.getWidth() / 2, pdf.internal.pageSize.getHeight() - 0.6, { align: "center" });
                    }
                    // Get the blob of the PDF
                    return pdf.output("blob");
                })
                .then((pdfBlob) => {
                    // Create a URL for the PDF blob
                    var pdfUrl = URL.createObjectURL(pdfBlob);

                    // Open the URL in a new tab
                    const printWindow = window.open(pdfUrl, '_blank', 'width=800,height=600');
                    printWindow.onload = () => {
                        printWindow.print();
                        URL.revokeObjectURL(pdfUrl);
                    };
                })
                .catch((error) => {
                    console.error("Error generating PDF:", error);
                });
        },
        filterAccountStatement() {
            this.getAccountStatement();
        },
        modalShown() {
            this.getAccountStatement();
        },
        getOneMonthBeforeDate() {
            // Get today's date
            let currentDate = new Date();

            // Remove one month to the current date
            currentDate.setMonth(currentDate.getMonth() - 1);

            // Format the date as 'YYYY-MM-DD'
            return currentDate.toISOString().substr(0, 10);
        },
        async refreshLoanTransactions(customer_id) {
            console.log(this.data)
            this.rewrtieLoading = true
            console.log(customer_id);
            await ApiService.post(`/transactions/rewrite`, {
                'customer_id': customer_id
            }).then((response) => {
                this.isLoadingSaving = false;
                this.$Progress.finish();
                toast.fire({
                    icon: "success",
                    title: response.data.message,
                });
                this.isSaving = false;
                this.filterAccountStatement();
                this.rewrtieLoading = false;
            }).catch((error) => {
                this.isSaving = false;
                this.$Progress.fail();
                if (error.response.data.errors) {
                    this.form.errors = error.response?.data?.errors;
                }
                this.rewrtieLoading = false;
            });
        },


    }
}
</script>